import { Component, EventEmitter, OnInit, Type, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CombosConfiguration, FunctionsService, HttpService, IButtonIcon, LocalStorageService, MenuBreadCrumb, MessageService, SessionService, TableColumns, TableConfiguration } from 'brainloper-ui';
import { NotificationsService } from 'app/services/notifications.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { ResourcesService } from 'app/services/resources.service';
import { MatStepper } from '@angular/material/stepper';
import { Equipment } from 'app/models2/maintenance/equipment';
import { User } from 'app/models2/administration/user';
import { HistoryInventory } from 'app/models2/inventory/history-inventory';
import { EmergingActivity } from 'app/models2/maintenance/emerging-activities';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { ItemComboLength } from 'app/models2/inventory/item-combo-length';
import { UtilsServiceService } from 'app/services/utils-service.service';
import { environment } from 'environments/environment';
import { TypeMaintenance } from '@edgarzon93/brainloper-shared';
import { WorkOrderService } from 'app/services/work-order.service';

@Component({
  selector: 'app-maintenance-request',
  templateUrl: './maintenance-request.component.html',
  styleUrls: ['./maintenance-request.component.scss']
})
export class MaintenanceRequestComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper;

  private urlGetComboUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`
  private urlComboEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`
  private urlPostActividadesEmergentes: string = `${EndpointDictionary.ActivityeEmerg.CRUD_ACTIVITY_EMERG_DATA}`
  public urlTablaEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_TABLE}`
  public urlTablaSolicitudesMtto: string = `${EndpointDictionary.ActivityeFrec.ACTIVITY_FREC_TABLE}`
  public urlGetItems: string = `${EndpointDictionary.Item.ITEM_COMBO}`;

  public typeOfMaintenance:TypeMaintenance[] = []

  public equipo:Equipment = {}
  public actividad: EmergingActivity = {}
  public labelActivity: Array<string> = []
  public actividades: EmergingActivity[] = []
  private comboUsuarios: User [] = []

  private rol: string = this.storage.get<string>('rol')
  public movil: boolean
  private itemsEvent: HistoryInventory = new HistoryInventory()
  public buttonActive: boolean = true

  public formStepeOne: UntypedFormGroup
  public formStepeThree: UntypedFormGroup

  public labels : Array<string> = []
   public recargarTablaEquipos = new EventEmitter<any>()
   public configurationEquipos: TableConfiguration = {
     edit: false,
     add: false,
     delete: false,
     selectable: false,
     primaryKey: 'id'
   }
   public columnasEquipos: TableColumns<Equipment>[] = [
     {
       ID: 'brand',
       label: 'Marca',
       type: 'text',
       style: {
         textAlign: 'center',
         movil: 'no-movil'
       },
     },
     {
       ID: 'code',
       label: 'Código',
       type: 'text',
       style: {
         textAlign: 'center',

       },
     }
   ]

//tabla actividades frecuentes
public titleSolicitudesMtto: string = screen.width > 360 ? 'Actividades' : ''
public recargarTablaSolicitudesMtto = new EventEmitter<any>()
public configurationSolicitudesMtto: TableConfiguration = {
  edit: false,
  add: false,
  delete: false,
  selectable: true,
  primaryKey: 'id'
}

public columnasSolicitudesMtto: TableColumns<EmergingActivity>[] = [
  {
    ID: 'description',
    label: 'Actividades Frecuentes',
    type: 'text',
    style: {
      textAlign: 'center'
    },
  }
]

public combosTypeOfMaintenance: CombosConfiguration = {
  visibleField: 'name',
  selectionField: 'id',
  label: 'Tipo Mantenimiento',
  fileTooltip:"description"
};

public menuBreadCrumb:Array<MenuBreadCrumb> = [
  {
    name:"Inicio",
    router:'/inicio',
  },
  {
  name:"Solicitudes de mantenimiento",
  current:true
}]

public inventoryModule: boolean = this.storage.get<boolean>('inventory_module')
public comboItemLength: number = 1

  constructor(
    public dialog: MatDialog,
    private message: MessageService,
    private http: HttpService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private functions: FunctionsService,
    public notifcationService: NotificationsService,
    private storage : LocalStorageService,
    private resourcesService : ResourcesService,
    private utilsService: UtilsServiceService,
    private session : SessionService,
    private workOrderService: WorkOrderService


  ) {
    this.formStepeOne = this.formBuilder.group({
      idEquipo: '',
    })
    this.formStepeThree = this.formBuilder.group({
      description: '',
      resources:'',
      executionDate:null,
      maintenanceType:null
    })
   }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true
    this.init()
  }
  canCreateRequest():boolean{
    var canCreateRequest = true;
    const maintenanceOrderCount = this.session.getData('maintenanceOrderCount') || 0;
    if (maintenanceOrderCount >= environment.createMaxDemandOT) {
      canCreateRequest = false;
      this.message.Warning('Advertencia', `No puedes crear más solicitudes, tienes más de ${environment.createMaxDemandOT} órdenes en ejecución, debes cerrarlas para poder crear más solicitudes.`)
      .then(() => {
        this.router.navigate(['/mantenimiento/ejecucion_OT'])
      }); 
     } 
    
     return canCreateRequest
    }
  
  
    


async init(){
  this.typeOfMaintenance = await this.workOrderService.getTypeOfMaintenance()
  let res: Array<Equipment> = await this.http.getDataBody(`${this.urlComboEquipos}`)
  let element: Equipment = res?.find(x => x.userId == this.storage.get<number>('userId'))
  if(element && element.state)
    this.clickFilaEquipos(element)

  this.comboUsuarios  = await this.http.getDataBody(`${this.urlGetComboUsuarios}`)
}

async clickFilaEquipos($event: Equipment) {
  if(!this.canCreateRequest()) return
  this.equipo = $event
  this.labels = [`Código del equipo: ${this.equipo.code}`]
  this.formStepeOne.controls.idEquipo.setValue(this.equipo.id)

}

async clickFilaSolicitudesMtto ($event) {
}

seleccionadosSolicitudesMtto($event: EmergingActivity[]){
  this.actividades = $event
  this.labelActivity = $event.map(x => {return x.description})
}

//recursos
async saveResources($event:HistoryInventory) {
  this.itemsEvent = $event
  this.stepper.next()
}

//combo item length
comboItemsLength($event: ItemComboLength){
  this.comboItemLength = $event.length
}
changesTypeOfMaintenance($event){
  this.formStepeThree.controls.maintenanceType.setValue($event)
}

async enviar(){
  if(!this.canCreateRequest()) return
  if(!this.utilsService.isValidDate(this.formStepeThree.controls.executionDate.value)){
    this.message.Error("Error", "Fecha de ejecución no válida")
    return
  }

  this.buttonActive = false
  this.message.openLoading('Cargando', 'Enviando solicitud')
  let res = ''
  let string = ''
  let costo = 0
  let total = 0
  for(let element of this.actividades){
    costo = total + element.cost   //parseInt()
    string = `${res}--${element.description}`
    res = string
    total = costo
  }

res = `${res} COMENTARIOS: ${this.formStepeThree.controls.description.value}`

let form: EmergingActivity  = {
  description:res,
  cost:total,
  requests:this.storage.get<number>('userId'),
  equipmentId:this.equipo.id,
  date:this.functions.dateForm(this.formStepeThree.controls.executionDate.value),
  maintenanceType:this.formStepeThree.controls.maintenanceType.value,
  resources: this.formStepeThree.controls.resources.value
}

  try {
    let res: GenericResponse = await this.http.postDataBody(`${this.urlPostActividadesEmergentes}`, form)
    if(res){
       let id_solicitud = res.insertId
       let description = `Equipo: ${this.equipo.code} / ${form.description}`

       await this.resourcesService.saveResources(this.itemsEvent.items, id_solicitud, false)
       if(this.rol != 'Jefe Mantenimiento'){
          await this.notifcationService.sendNotificationRequestQueue(description, id_solicitud)
       }
       await this.notifcationService.sendNotificationAutorizeRequest(description, id_solicitud)

      this.message.closeLoading()
      this.message.SuccessToast('Solicitud de mantenimiento creada correctamente')
      setTimeout(() => {
        this.router.navigate(['/inicio'])
      }, 500);
    }
  } catch (error) {
    this.message.Error('Error', error['message'])
  }

}

errorMessage(){
  this.message.Error('Error', 'Complete los campos')
}




}
